<template>
  <el-form id="searchForm">
    <el-form-item></el-form-item>
    <el-form-item>
      <div>
        <el-scrollbar style="height:100%">
          <el-tree style="width: 100%"
                   ref="tree"
                   :data="data"
                   node-key="index"
                   :props="defaultProps"
                   :default-expand-all="false"
                   @node-click="handleNodeClick"
                   :current-node-key="currentKey"
                   :accordion="true"
                   :appendToBody="true"
                   :highlight-current="true"
                   @check="clickInformation"
                   :default-expanded-keys="defaultShowNodes"
          >
          </el-tree>
        </el-scrollbar>
      </div>
    </el-form-item>
    <el-form-item>
    </el-form-item>
  </el-form>
</template>
<script>
import {getDataInSessionStorage, saveDataToSessionStorage} from "@/utils/sessionStorage";

export default {
  inject: ['reload'],
  name: 'ResultsNav',
  props:
    {
      data: [],
      analyzeId: {
        type: String,
        default: ""
      },
      projectId: {
        type: String,
        default: ""
      },
    },
  data() {
    return {
      filterText: '',
      defaultProps: {
        children: 'sons',
        label: 'name'
      },
      isCollapse: false,
      currentKey: 14,
      treeExpandData: [],
      provincialCenterId: '',
      defaultShowNodes: [],
      loading: true,
    }
  },
  watch: {
    currentKey(id) {
      if (id) {
        this.$nextTick(() => {
          this.$refs["tree"].setCurrentKey(id);
        })
      } else {
        this.$refs["tree"].setCurrentKey(null);
      }
    },
    data(value) {
      if (value) {
        this.$store.commit('setFirstOutLoading')
        this.getOriginState(value)
        this.getDefaultShowNodes(1, value);
        if (getDataInSessionStorage(('currentKey'))) {
          this.currentKey = getDataInSessionStorage(('currentKey'))
        } else {
          this.currentKey = value.length
        }
      }
    },
  },
  mounted() {

  },
  methods: {
    //树的节点展开
    getDefaultShowNodes (num, children) {//树的节点展开
      this.defaultShowNodes = []
      --num
      if (num >= 0) {
        let node = getDataInSessionStorage('parentKey')
        if ((!node || node !== '99')) {//空或者不为99
          if (!node) {
            node = 1
          }
          this.defaultShowNodes.push(children[node].index)
        }
      }
    },
    //获取初始的状态
    getOriginState (menuList) {
      var lastPath = getDataInSessionStorage('fullPath')
      if (window.performance.navigation.type === 0) {  //判断是否首次进入
        lastPath = ''
      }
      if (!lastPath) {
        // 没有进入
        lastPath = menuList[1].name
        saveDataToSessionStorage('parentPath', lastPath)
        saveDataToSessionStorage('parentKey', '1')//打开的主节点
        saveDataToSessionStorage('currentKey', menuList[1].sons.length > 0 ? menuList.length : '1')//次节点
        this.currentKey = getDataInSessionStorage(('currentKey'))
      } else {
        if (lastPath === '00分析详情') {
          saveDataToSessionStorage('currentKey', '99')
          this.currentKey = '99'
        }
      }
      this.$store.commit('setPath', lastPath)
    },
    //点击目录节点
    handleNodeClick (data) {
      let index = data.index
      if (data.path) {//点击的是目录（仅有一层的父节点，或者子节点）
        this.$store.commit('setDefaults')//设置加载的默认值
        let fullPath = ''
        if (data.path.includes('/')) {
          saveDataToSessionStorage('parentKey', getDataInSessionStorage('parentKeyTemp'))//保存父节点的index
          fullPath = getDataInSessionStorage('parentPath') + '/' + data.name
        } else {
          //通过搜索进来且只有一层目录
          if (data.search) {
            let parentKey=getDataInSessionStorage('parentKey')
            this.$refs.tree.store.nodesMap[parentKey].expanded = false//关闭指定的节点
          }
          fullPath = data.name
        }
        saveDataToSessionStorage('fullPath', fullPath)
        this.$store.commit('setPath', fullPath)
        saveDataToSessionStorage('currentKey', index)
        this.currentKey = index
        this.isModelSuccess(data.path)
      } else {
        // 点击的路径的上一层
        let parentPth = data.name
        saveDataToSessionStorage('parentPath', parentPth)
        saveDataToSessionStorage('parentKeyTemp',index)//暂存父节点的index
        //通过搜索进来
        if (data.search) {
          this.$refs.tree.store.nodesMap[index].expanded = false//关闭指定的节点
          this.getDefaultShowNodes(1, this.data)
        }
        if (index === 99) {
          this.$store.commit('setPath', data.name)//点击父节点记录
          saveDataToSessionStorage('parentPath', data.name)
          saveDataToSessionStorage('currentKey', '99')//设置当前高亮的index
          this.$router.push({
            path: '/AnalyzeInformation',
            query: {
              projectId: this.projectId,
              analyzeId: this.analyzeId,
              path: data.path,
              index: index,
            }
          })
        }
      }
    },
    //判断该模块是否成功
    async isModelSuccess(path) {
      const res = await this.$http.get('/preview/dirFiles/' + this.projectId + "/" + this.analyzeId + "/" + path)
      if (res) {
        this.reload()
        if (res.code === 5856) {
          await this.$router.push({
            path: '/errModule',
            query: {projectId: this.projectId, analyzeId: this.analyzeId, path: path}
          });
        } else {
          await this.$router.push({
            path: '/analyzeContent',
            query: {projectId: this.projectId, analyzeId: this.analyzeId, path: path}
          });
        }
      }
    },
    clickInformation(data) {
    }
  },
}
</script>

<style lang="scss">

.scrollbar-wrapper {
  overflow-x: hidden !important;
}

/**
 * layout
 */
.sidebar {
  position: fixed;
  z-index: 2;
  height: 100%;
  margin-top: 30px;
  background-color: #ffffff;
}

.el-tree {
  background-color: #ffffff !important;
  min-height: 450px;
  max-height: 800px;
  //height: 100%;
  font-family: "Microsoft YaHei";
  color: #313030 !important;
  font-size: 16px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  width: 215px;
}

input::-webkit-input-placeholder {
  color: #5e5c5c !important
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #5e5c5c !important
}

input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #5e5c5c !important
}

.el-tree-node:focus > .el-tree-node__content {
  background-color: #66b1ff87 !important;
}

.el-tree-node__content:hover {
  background-color: #fdf5e2 !important;
}

.el-tree-node__content {
  height: 35px !important;
  font-size: 27px !important;
}

.el-tree-node__label {
  font-size: 15px !important;
}

.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #fdf5e2 !important;
  color: #fdbb38;
}

.sidebar-wrapper .el-scrollbar__wrap {
  overflow-x: hidden;
}

.is-horizontal {
  display: none;
}

#searchForm {
  height: 100%;
  width: 290px !important;
}

.el-form-item__content {
  height: 100%;
}
</style>
<!--<style lang="scss"   scoped>-->
<!--.el-input__inner{-->
<!--  height: 20px!important;-->
<!--  line-height: 20px!important;-->
<!--}-->
<!--</style>-->
